import React from 'react';
import Hero from '../components/Hero';
import Pedagogy from '../components/Pedagogy';
import Courses from '../components/Courses';
import Roadmaps from '../components/Roadmaps';
import ComparisonMatrix from '../components/ComparisonMatrix';
// import Faculty from '../components/Faculty';
import FAQ from '../components/FAQ';
import CampusContact from '../components/CampusContact';

function Home() {
  return (
    <main>
      <Hero />
      <Pedagogy />
      <Courses />
      <Roadmaps />
      <ComparisonMatrix />
      {/* <Faculty /> */}
      <FAQ />
      <CampusContact />
    </main>
  );
}

export default Home;
